module.exports = {
    DEBIT_MOVEMENTS: 'debit',
    CREDIT_MOVEMENTS: 'credit',
    ALL_MOVEMENTS: 'all',
    ALL_ACCOUNTS: 'all',
    CATEGORY: 'category',
    ALL_CATEGORIES: 'allCategories',
    BANK: 'bank',
    ALL_BANKS: 'allBanks',
    DATE: 'date',
    CUSTOM_ACCOUNTS: 'customAccounts',
    LAST_YEAR_COMPARISON: 'lastYearComparison',
    LAST_MONTH_COMPARISON: 'lastMonthComparison',
    CONTRACT_TYPE: 'contractType',
}
